import { render, staticRenderFns } from "./Pixel.vue?vue&type=template&id=61ad74ae&scoped=true&"
import script from "./Pixel.vue?vue&type=script&lang=js&"
export * from "./Pixel.vue?vue&type=script&lang=js&"
import style0 from "./Pixel.vue?vue&type=style&index=0&id=61ad74ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ad74ae",
  null
  
)

export default component.exports